<div id="content" class="allcp-form" ng-controller="DayendController" ng-init="all()">
    <div ng-include="'modules/company/menus/dayend_menu.html'"></div>
    <div class="panel-body">
        <div class="table-responsive" ng-if="data.dayends.data.length > 0">
            <small class="pull-right pr10 total-record">Toplam Kayıt : {{ data.dayends.total }}</small>
            <br>
            <dir-pagination-controls boundary-links="true" on-page-change="getPage(newPageNumber)" template-url="dirPagination.tpl.html" class="pagination-lg pagination pull-right pr10">
            </dir-pagination-controls>
            <table class="table table-hover tc-checkbox-1 fs13">
                <thead>
                    <tr class="bg-light">
                        <th class="text-center w100">#</th>
                        <th>
                            Gün
                            <a ng-click="sort('date','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                <i class="fa fa-sort-alpha-desc"></i>
                            </a>
                            <a ng-click="sort('date','asc')" ng-if="filterData.sort == 'desc'">
                                <i class="fa fa-sort-alpha-asc"></i>
                            </a>
                        </th>
                        <th>
                            Personel
                            <a ng-click="sort('worker_id','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                <i class="fa fa-sort-alpha-desc"></i>
                            </a>
                            <a ng-click="sort('worker_id','asc')" ng-if="filterData.sort == 'desc'">
                                <i class="fa fa-sort-alpha-asc"></i>
                            </a>
                        </th>
                        <th>
                            Toplam Girilen
                            <a ng-click="sort('item_count','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                <i class="fa fa-sort-alpha-desc"></i>
                            </a>
                            <a ng-click="sort('item_count','asc')" ng-if="filterData.sort == 'desc'">
                                <i class="fa fa-sort-alpha-asc"></i>
                            </a>
                        </th>
                        <th>
                            Toplam Tutar
                            <a ng-click="sort('price','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                <i class="fa fa-sort-alpha-desc"></i>
                            </a>
                            <a ng-click="sort('price','asc')" ng-if="filterData.sort == 'desc'">
                                <i class="fa fa-sort-alpha-asc"></i>
                            </a>
                        </th>
                        <th>
                            Kalan Tutar
                            <a ng-click="sort('remaining_price','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                <i class="fa fa-sort-alpha-desc"></i>
                            </a>
                            <a ng-click="sort('remaining_price','asc')" ng-if="filterData.sort == 'desc'">
                                <i class="fa fa-sort-alpha-asc"></i>
                            </a>
                        </th>
                        <th>
                            Durum
                            <a ng-click="sort('status','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                <i class="fa fa-sort-alpha-desc"></i>
                            </a>
                            <a ng-click="sort('status','asc')" ng-if="filterData.sort == 'desc'">
                                <i class="fa fa-sort-alpha-asc"></i>
                            </a>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr dir-paginate="item in data.dayends.data | itemsPerPage: 30" total-items="data.dayends.total" current-page="data.dayends.current_page">
                        <td class="text-center">
                            <label class="option block mn">
                                <input type="checkbox" name="deleted[]" ng-checked="deleted.indexOf(item.id) > -1" ng-click="toggleSelection(item.id)">
                                <span class="checkbox mn"></span>
                            </label>
                        </td>
                        <td class="clickable-row" ng-click="getDayendDetail(item.id)">{{ item.date | amDateFormat:'MM/DD/YYYY' }}</td>
                        <td class="clickable-row" ng-click="getDayendDetail(item.id)">{{ item.worker ? item.worker.full_name : '-' }}</td>
                        <td class="clickable-row" ng-click="getDayendDetail(item.id)">{{ item.item_count }}</td>
                        <td class="clickable-row" ng-click="getDayendDetail(item.id)">{{ item.total_price }} ₺</td>
                        <td class="clickable-row" ng-click="getDayendDetail(item.id)">{{ item.remaining_price }} ₺</td>
                        <td class="clickable-row" ng-click="getDayendDetail(item.id)">
                            <span class="badge badge-success" ng-if="item.status == 1">Onaylı</span>
                            <span class="badge badge-warning" ng-if="item.status == 0">Onaysız</span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <dir-pagination-controls boundary-links="true" on-page-change="getPage(newPageNumber)" template-url="dirPagination.tpl.html" class="pagination-lg pagination pull-right pr10">
            </dir-pagination-controls>
        </div>
        <div class="table-responsive" ng-if="data.dayends.data.length == 0">
            <div class="alert alert-default pastel">
                <i class="fa fa-info pr10"></i>
                <strong>
                    Gün sonu kaydı bulunamadı!
                </strong>
            </div>
        </div>
    </div>
    <div ng-include="'modules/company/settings/partials/delete.html'"></div>
</div>